import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Toaster } from 'sonner';

export const Layout = ({ children, showChrome = true }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      {showChrome && <Navbar />}
      <main id="main-content" className="flex-1">
        {children}
      </main>
      {showChrome && <Footer />}
      <Toaster position="bottom-right" richColors />
    </div>
  );
};
